import { render, staticRenderFns } from "./BadgeWrapper.vue?vue&type=template&id=71c8b61a&scoped=true&"
import script from "./BadgeWrapper.vue?vue&type=script&lang=ts&"
export * from "./BadgeWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeWrapper.vue?vue&type=style&index=0&id=71c8b61a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8b61a",
  null
  
)

export default component.exports